import React from 'react';
import ReactDOM from 'react-dom/client';
import Page from './page'
import reportWebVitals from './reportWebVitals';

import "./assets/css/main.css";
import "./assets/css/bootstrap.scss";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
